// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.missionContainer {
  background-color: #172639;
  color: white;
  padding: 20px 60px 90px;
}

.missionHeading {
  color: #f2d38c;
  font-weight: 800;
  font-size: 2.75rem;
  margin-bottom: 24px;
}

.missionText {
  color: rgba(255, 255, 255, 0.88);
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .missionContainer {
    padding: 10px 30px 60px;
  }

  .missionHeading {
    font-size: 2.1rem;
  }
}

@media (max-width: 768px) {
  .missionContainer {
    padding: 10px 20px 45px;
    text-align: center;
  }

  .missionHeading {
    font-size: 1.8rem;
  }

  .missionText {
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OurMission.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".missionContainer {\n  background-color: #172639;\n  color: white;\n  padding: 20px 60px 90px;\n}\n\n.missionHeading {\n  color: #f2d38c;\n  font-weight: 800;\n  font-size: 2.75rem;\n  margin-bottom: 24px;\n}\n\n.missionText {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 1.05rem;\n  line-height: 1.8;\n  margin-bottom: 0;\n}\n\n@media (max-width: 992px) {\n  .missionContainer {\n    padding: 10px 30px 60px;\n  }\n\n  .missionHeading {\n    font-size: 2.1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .missionContainer {\n    padding: 10px 20px 45px;\n    text-align: center;\n  }\n\n  .missionHeading {\n    font-size: 1.8rem;\n  }\n\n  .missionText {\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
